import React from 'react';
import { RewardStockContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Displays, Inputs, Tables } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import * as XLSX from 'xlsx';
import moment from 'moment';
import 'moment-timezone';
import { RenderCommaMoney } from 'utils/functions/FormatMoney';

const TIME_ZONE = 'Asia/Bangkok';

const FILTER_FIELDS = [
  'name',
  'type',
  'is_active',
  'stock_start_date',
  'stock_end_date',
  'start_date',
  'end_date',
];

// map type ของ reward ให้ตรงกับหัวข้อ Coupon Type ในไฟล์รายงานที่ลูกค้าใช้
const RENDER_COUPON_TYPE = (type) => {
  switch (type) {
    case '1':
      return 'E-coupon';
    case '2':
      return 'Coupon';
    case '3':
      return 'Others';
    default:
      return '';
  }
};

// InputFilter (dateRank) ส่งค่ามาเป็น YYYY-MM-DD
// ถ้าเลือกไม่ครบคู่หรือรูปแบบไม่ถูกต้อง ถือว่าไม่ได้กรองช่วงวันนั้น
const parseDateRange = (start, end) => {
  if (!start || !end) return null;
  const startDate = moment.tz(start, 'YYYY-MM-DD', TIME_ZONE).startOf('day');
  const endDate = moment.tz(end, 'YYYY-MM-DD', TIME_ZONE).endOf('day');
  if (!startDate.isValid() || !endDate.isValid()) return null;
  return { startDate, endDate };
};

// แปลง query string ของ url เป็น state ของ filter (ใช้ตอนเข้าหน้าครั้งแรก / กด refresh)
const parseUrlQuery = (search) => {
  const searchParams = new URLSearchParams(search || '');
  const currentPage = Number(searchParams.get('page')) || 1;
  let filterValues = {};
  FILTER_FIELDS.forEach((key) => {
    filterValues[key] = searchParams.get(key) || '';
  });
  // ตัด key ที่ไม่ใช่ filter ของหน้านี้ และค่าว่างออก เพื่อไม่ให้ url รก
  Array.from(searchParams.keys()).forEach((key) => {
    if (FILTER_FIELDS.indexOf(key) === -1 || !searchParams.get(key)) {
      searchParams.delete(key);
    }
  });
  const filterString = searchParams.toString();
  return {
    filterQuery: filterString ? `?${filterString}` : '',
    filterValues,
    currentPage,
  };
};

class RewardStockContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    allData: [],
    data: [],
    // ใช้ remount InputFilter ตอนกดล้างค่า เพราะ input ข้างในเป็น uncontrolled
    filterKey: 0,
    // เก็บ filter เดิมไว้ที่ url เพื่อให้ refresh แล้วเงื่อนไขและหน้าที่เลือกยังอยู่
    ...parseUrlQuery(this.props.router.location.search),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.fetchData(filterQuery, currentPage);
  }

  // รวมข้อมูล reward (สต็อก) กับ reward history (ยอดแลกในช่วงวันที่เลือก) ให้ได้ตามฟอร์แมตรายงานของลูกค้า
  fetchData = async (stringQuery, page) => {
    const searchParams = new URLSearchParams(stringQuery || '');
    const name = searchParams.get('name') || '';
    const type = searchParams.get('type') || '';
    const isActive = searchParams.get('is_active') || '';
    const stockRange = parseDateRange(
      searchParams.get('stock_start_date'),
      searchParams.get('stock_end_date')
    );
    const redeemRange = parseDateRange(
      searchParams.get('start_date'),
      searchParams.get('end_date')
    );

    let rewardQueryArr = ['pagination=false', 'sort=sequence', 'is_delete=true'];
    if (name) {
      rewardQueryArr.push(`name=${encodeURIComponent(name)}`);
    }
    if (type && type !== '0') {
      rewardQueryArr.push(`type=${type}`);
    }
    if (isActive === 'true' || isActive === 'false') {
      rewardQueryArr.push(`is_active=${isActive}`);
    }

    let resArr = await Promise.all([
      portalService.GET_REWARD_LIST(`?${rewardQueryArr.join('&')}`),
      // ดึงเฉพาะตอนเลือกช่วงวันที่แลก ถ้าไม่เลือกใช้ยอดแลกสะสมจาก reward ได้เลย
      // ดึงตั้งแต่ต้นจนถึงวันสิ้นสุดของช่วง (ไม่ใช่แค่ในช่วง) เพราะ Remain stock
      // ต้องเป็นของคงเหลือจริง ณ สิ้นช่วง = สต็อก - ยอดแลกสะสมทั้งหมด
      // แล้วค่อยแยกนับใน js ว่าใบไหนอยู่ในช่วงที่เลือก
      redeemRange
        ? portalService.GET_REWARD_HISTORY_LIST(
            `?pagination=false&status=2&start_date=2000-01-01&end_date=${searchParams.get(
              'end_date'
            )}`
          )
        : null,
    ]);

    const resReward = resArr[0];
    const resHistory = resArr[1];
    if (!resReward || resReward.status !== 200) {
      this.setState({ isLoading: false });
      return;
    }

    // แยกนับ 2 ชุด เพราะสองคอลัมน์นี้ใช้ฐานคนละแบบ
    //   redeemByRewardId      = แลกเฉพาะในช่วงที่เลือก  -> คอลัมน์ Redeem / Total Redeem
    //   redeemToDateByRewardId = แลกสะสมถึงสิ้นช่วง      -> คอลัมน์ Remain / Total Remain
    let redeemByRewardId = null;
    let redeemToDateByRewardId = null;
    if (redeemRange && resHistory && resHistory.status === 200) {
      redeemByRewardId = {};
      redeemToDateByRewardId = {};
      resHistory.data.docs.forEach((e) => {
        const key = String(e.reward_ref_id);
        const qty = Number(e.reward_redeem_amount || 0);
        // api ดึงมาถึงสิ้นช่วงอยู่แล้ว ทุกใบจึงนับเป็นยอดสะสม
        redeemToDateByRewardId[key] = (redeemToDateByRewardId[key] || 0) + qty;
        if (
          moment(e.created_at).tz(TIME_ZONE).isSameOrAfter(redeemRange.startDate)
        ) {
          redeemByRewardId[key] = (redeemByRewardId[key] || 0) + qty;
        }
      });
    }

    const rows = resReward.data.docs.reduce((result, e) => {
      // stock_updated_at คือวันลงสต็อกที่เชื่อถือได้ (ระบบบันทึกเอง + backfill ย้อนหลังให้แล้ว)
      // ส่วน uploaded_at ของเก่าเพี้ยนจากบั๊ก default: new Date() จึงใช้เป็นตัวสำรองเท่านั้น
      const stockDateRaw = e.stock_updated_at || e.uploaded_at;
      if (stockRange) {
        const stockDate = stockDateRaw
          ? moment(stockDateRaw).tz(TIME_ZONE)
          : null;
        if (
          !stockDate ||
          !stockDate.isBetween(
            stockRange.startDate,
            stockRange.endDate,
            null,
            '[]'
          )
        ) {
          return result;
        }
      }
      const value = Number(e.cost || 0);
      const currentStock = Number(e.total_amount || 0);
      const redeemQty = redeemByRewardId
        ? redeemByRewardId[String(e._id)] || 0
        : Number(e.redeem_amount || 0);
      // ของคงเหลือต้องหักยอดแลกสะสมทั้งหมดถึงสิ้นช่วง ไม่ใช่หักเฉพาะที่แลกในช่วงนั้น
      // ไม่งั้นของที่แลกไปก่อนหน้าจะ "กลับมามีของ" ทุกครั้งที่เลื่อนช่วงวันที่
      const redeemToDate = redeemToDateByRewardId
        ? redeemToDateByRewardId[String(e._id)] || 0
        : Number(e.redeem_amount || 0);
      const remainStock = currentStock - redeemToDate;
      result.push({
        _id: e._id,
        stock_date: stockDateRaw,
        reward_name: e.name,
        coupon_type: RENDER_COUPON_TYPE(e.type),
        is_active: e.is_active,
        stock_last_amount: e.stock_last_amount,
        stock_update_count: Number(e.stock_update_count || 0),
        sold_out_at: e.sold_out_at,
        redeem_point: Number(e.redeem_point || 0),
        value: value,
        current_stock: currentStock,
        redeem_qty: redeemQty,
        remain_stock: remainStock,
        total_redeem: redeemQty * value,
        total_remain: remainStock * value,
      });
      return result;
    }, []);

    this.setPageData(rows, page, stringQuery);
  };

  // ทำ pagination ฝั่ง frontend เพราะข้อมูลถูกรวมจาก 2 api แล้ว
  setPageData = (rows, page, query) => {
    const { perPage } = this.state;
    const lastPage = Math.max(1, Math.ceil(rows.length / perPage));
    const currentPage = Math.min(Math.max(page || 1, 1), lastPage);
    const filterQuery = query === undefined ? this.state.filterQuery : query;
    this.setState({
      isLoading: false,
      allData: rows,
      data: rows.slice((currentPage - 1) * perPage, currentPage * perPage),
      pagination: {
        last_page: lastPage,
        current_page: currentPage,
      },
      currentPage,
    });
    this.handleSyncUrlQuery(filterQuery, currentPage);
  };

  handleSyncUrlQuery = (query, page) => {
    const searchParams = new URLSearchParams(query || '');
    Array.from(searchParams.keys()).forEach((key) => {
      if (!searchParams.get(key)) {
        searchParams.delete(key);
      }
    });
    if (page > 1) {
      searchParams.set('page', page);
    }
    const search = searchParams.toString();
    this.props.router.navigate(
      { search: search ? `?${search}` : '' },
      { replace: true }
    );
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseUrlQuery(e);
    this.setState({
      ...parsedQuery,
      currentPage: 1,
      isLoading: true,
    });
    this.fetchData(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseUrlQuery(''),
      isLoading: true,
      filterKey: prevState.filterKey + 1,
    }));
    this.fetchData('', 1);
  };

  handlePageClick = (e) => {
    const { allData, filterQuery } = this.state;
    this.setPageData(allData, e.selected + 1, filterQuery);
  };

  handleExport = () => {
    const { allData } = this.state;
    this.setState({
      isBgLoading: true,
    });
    var wb = XLSX.utils.book_new();
    // เก็บเป็นตัวเลขจริง (ไม่ใส่ comma) เพื่อให้ลูกค้าเอาไปคำนวณต่อใน excel ได้
    var ws_data = allData.reduce((result, e) => {
      result.push([
        e.stock_date
          ? moment(e.stock_date).tz(TIME_ZONE).format('DD/MM/YYYY')
          : '',
        e.reward_name,
        e.coupon_type,
        e.redeem_point,
        e.value,
        e.current_stock,
        e.redeem_qty,
        e.remain_stock,
        e.total_redeem,
        e.total_remain,
      ]);
      return result;
    }, []);
    ws_data.splice(0, 0, [
      'Stock Date',
      'Reward Name',
      'Coupon Type',
      'Redeem point',
      'Value (THB)',
      'Current stock (pcs)',
      'Redeem (pcs)',
      'Remain stock (pcs)',
      'Total Redeem (THB)',
      'Total Remain (THB)',
    ]);
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws['!cols'] = [
      { wch: 12 },
      { wch: 45 },
      { wch: 12 },
      { wch: 13 },
      { wch: 12 },
      { wch: 18 },
      { wch: 13 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, 'rewards report');
    XLSX.writeFile(
      wb,
      `MISUMI rewards report ${moment().tz(TIME_ZONE).format('DD-MM-YYYY')}.xlsx`
    );
    this.setState({
      isBgLoading: false,
    });
  };

  renderSummary = () => {
    const { allData } = this.state;
    return allData.reduce(
      (result, e) => {
        result.current_stock += e.current_stock;
        result.redeem_qty += e.redeem_qty;
        result.remain_stock += e.remain_stock;
        result.total_redeem += e.total_redeem;
        result.total_remain += e.total_remain;
        return result;
      },
      {
        current_stock: 0,
        redeem_qty: 0,
        remain_stock: 0,
        total_redeem: 0,
        total_remain: 0,
      }
    );
  };

  render() {
    const { isLoading, isBgLoading, pagination, data, filterValues, filterKey } =
      this.state;
    const summary = this.renderSummary();

    return (
      <RewardStockContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="470px" />
        ) : (
          <>
            <div className="summary_layout">
              <div className="summary_block">
                <div className="sb_label">Current stock (pcs)</div>
                <div className="sb_value">
                  {RenderCommaMoney(summary.current_stock, true)}
                </div>
              </div>
              <div className="summary_block">
                <div className="sb_label">Redeem (pcs)</div>
                <div className="sb_value">
                  {RenderCommaMoney(summary.redeem_qty, true)}
                </div>
              </div>
              <div className="summary_block">
                <div className="sb_label">Remain stock (pcs)</div>
                <div className="sb_value">
                  {RenderCommaMoney(summary.remain_stock, true)}
                </div>
              </div>
              <div className="summary_block">
                <div className="sb_label">Total Redeem (THB)</div>
                <div className="sb_value">
                  {RenderCommaMoney(summary.total_redeem, true)}
                </div>
              </div>
              <div className="summary_block">
                <div className="sb_label">Total Remain (THB)</div>
                <div className="sb_value">
                  {RenderCommaMoney(summary.total_remain, true)}
                </div>
              </div>
            </div>
            <Tables.Standard
              columns={columns}
              data={data}
              showPagination
              pagination={pagination}
              handlePageClick={this.handlePageClick}
            />
          </>
        )}
      </RewardStockContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: 'name',
    length: '311px',
    filter: {
      fieldQuery: 'name',
      type: 'text',
      defaultValue: filterValues.name,
      label: 'Reward name : ',
      placeholder: 'Reward name',
    },
  },
  {
    accessor: 'type',
    length: '311px',
    filter: {
      fieldQuery: 'type',
      type: 'dropdown',
      defaultValue: filterValues.type,
      options: [
        {
          label: 'All',
          value: '0',
        },
        {
          label: 'E-coupon',
          value: '1',
        },
        {
          label: 'Coupon',
          value: '2',
        },
        {
          label: 'Others',
          value: '3',
        },
      ],
      placeholder: 'Coupon type',
      label: 'Coupon type : ',
    },
  },
  {
    accessor: 'is_active',
    length: '311px',
    filter: {
      fieldQuery: 'is_active',
      type: 'dropdown',
      defaultValue: filterValues.is_active,
      options: [
        {
          label: 'All',
          value: '',
        },
        {
          label: 'Active',
          value: 'true',
        },
        {
          label: 'Inactive',
          value: 'false',
        },
      ],
      placeholder: 'Status',
      label: 'Status : ',
    },
  },
  {
    accessor: 'stock_date',
    filter: {
      fieldQuery: 'stock_date',
      type: 'dateRank',
      startFieldQuery: 'stock_start_date',
      endFieldQuery: 'stock_end_date',
      defaultStartValue: filterValues.stock_start_date,
      defaultEndValue: filterValues.stock_end_date,
      label: 'Stock date : ',
    },
  },
  {
    accessor: 'redeem_date',
    filter: {
      fieldQuery: 'redeem_date',
      type: 'dateRank',
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: 'Redeem date : ',
    },
  },
];

const columns = [
  {
    Header: <div style={{ textAlign: 'left' }}>Stock Date</div>,
    accessor: 'stock_date',
    Cell: (props) =>
      props.value ? moment(props.value).tz(TIME_ZONE).format('DD/MM/YYYY') : '-',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Reward Name</div>,
    accessor: 'reward_name',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Coupon Type</div>,
    accessor: 'coupon_type',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Status</div>,
    accessor: 'is_active',
    Cell: (props) => (
      <div className="body_status">
        <div
          className="round"
          style={{ background: props.value === true ? 'green' : 'red' }}
        />
        <div className="label_status">
          {props.value === true ? 'Active' : 'Inactive'}
        </div>
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Redeem point</div>,
    accessor: 'redeem_point',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Value (THB)</div>,
    accessor: 'value',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Current stock (pcs)</div>,
    accessor: 'current_stock',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Redeem (pcs)</div>,
    accessor: 'redeem_qty',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Remain stock (pcs)</div>,
    accessor: 'remain_stock',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Total Redeem (THB)</div>,
    accessor: 'total_redeem',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Total Remain (THB)</div>,
    accessor: 'total_remain',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Last added (pcs)</div>,
    accessor: 'stock_last_amount',
    Cell: (props) =>
      props.value === undefined || props.value === null ? (
        <div style={{ textAlign: 'right' }}>-</div>
      ) : (
        <div style={{ textAlign: 'right' }}>
          {props.value > 0 ? '+' : ''}
          {RenderCommaMoney(Number(props.value), true)}
        </div>
      ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Times added</div>,
    accessor: 'stock_update_count',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>{Number(props.value || 0)}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Sold out date</div>,
    accessor: 'sold_out_at',
    Cell: (props) =>
      props.value ? moment(props.value).tz(TIME_ZONE).format('DD/MM/YYYY') : '-',
  },
];

export default withRouter(RewardStockContainer);
